import { icon, title } from 'core/style';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { WithStyles, ITheme } from 'core/style/interfaces';
import { ifBrowser } from 'core/utils';
import React from 'react';
import CheckboxIcon from '../../../svg/checkbox.svg';

const styles = (theme: ITheme) =>
    createStyles({
        wrap: {},
        item: {
            flexDirection: 'row',
            display: 'flex',
        },
        icon: {
            flex: 'none',
            ...icon,
            height: 30,
            width: 30,
            marginRight: 0.5 + 'rem',
            fill: '#333',

            [theme.breakpoints.down('sm')]: {
                height: 25,
                width: 25,
            },
        },
        text: {
            [theme.breakpoints.down('sm')]: {
                maxWidth: 80 + '%',
                marginLeft: 15,
                marginBottom: 20,
            },
        },
        title: {
            ...title({ size: 'h2' }),
            marginBottom: '0.75rem',

            [theme.breakpoints.down('sm')]: {
                textAlign: 'center',
                fontSize: 1.25 + 'rem',
            },
        },
    });

type IRenderSalesPointsProps = {
    richSalesPoints: string;
} & WithStyles<typeof styles>;

const ProductSalesPoints: React.StatelessComponent<IRenderSalesPointsProps> = ({ classes, richSalesPoints }) => {
    if (!ifBrowser()) return null;

    const elementsArr = [];
    const parser = new DOMParser();
    const html = parser.parseFromString(richSalesPoints, 'text/html');
    const elements =
        html.getElementsByTagName('li').length > 0 ? html.getElementsByTagName('li') : html.getElementsByTagName('p');

    for (let i = 0; i < elements.length; i++) {
        elementsArr.push(elements[i].innerHTML);
    }

    return (
        <div className={classes.wrap}>
            <h2 className={classes.title}>Чему вы научитесь</h2>
            {elementsArr.map((element, index) => (
                <span className={classes.item} key={index}>
                    <CheckboxIcon className={classes.icon} />
                    <p className={classes.text} dangerouslySetInnerHTML={{ __html: element }} />
                </span>
            ))}
        </div>
    );
};

export default injectSheet(styles, 'ProductSalesPoints')(ProductSalesPoints);
